var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg6Speakerphone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 1048,
    viewBox: "0 0 1440 1048",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M890 450.98C890 455.489 879.685 459.145 866.96 459.145C854.236 459.145 843.921 455.489 843.921 450.98C843.921 450.648 843.977 448.321 844.085 448C845.451 443.952 855.172 440.814 866.96 440.814C878.749 440.814 888.47 443.952 889.836 448C889.944 448.321 890 450.648 890 450.98Z",
    fill: "url(#paint0_linear_1989_6865)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M890 447.165C890 451.675 879.685 455.33 866.96 455.33C854.236 455.33 843.921 451.675 843.921 447.165C843.921 442.656 854.236 439 866.96 439C879.685 439 890 442.656 890 447.165Z",
    fill: "url(#paint1_linear_1989_6865)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M883.901 446.938C883.901 450.32 876.468 453.062 867.299 453.062C858.13 453.062 850.697 450.32 850.697 446.938C850.697 443.556 858.13 440.814 867.299 440.814C876.468 440.814 883.901 443.556 883.901 446.938Z",
    fill: "url(#paint2_linear_1989_6865)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M883.901 445.485C883.901 448.867 876.468 451.609 867.299 451.609C858.13 451.609 850.697 448.867 850.697 445.485C850.697 442.103 858.13 439.361 867.299 439.361C876.468 439.361 883.901 442.103 883.901 445.485Z",
    fill: "url(#paint3_linear_1989_6865)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M882.935 452.538C887.019 451.091 889.322 449.169 889.322 447.165C889.322 445.161 887.019 443.24 882.935 441.792C878.881 440.356 873.235 439.454 866.96 439.454C860.686 439.454 855.04 440.356 850.986 441.792C846.902 443.24 844.599 445.161 844.599 447.165C844.599 449.169 846.902 451.091 850.986 452.538C855.04 453.975 860.686 454.877 866.96 454.877C873.235 454.877 878.881 453.975 882.935 452.538ZM866.96 455.33C879.685 455.33 890 451.675 890 447.165C890 442.656 879.685 439 866.96 439C854.236 439 843.921 442.656 843.921 447.165C843.921 451.675 854.236 455.33 866.96 455.33Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.96 454.197C867.147 454.197 867.299 454.095 867.299 453.97C867.299 453.844 867.147 453.743 866.96 453.743C866.773 453.743 866.622 453.844 866.622 453.97C866.622 454.095 866.773 454.197 866.96 454.197ZM866.96 454.423C867.335 454.423 867.638 454.22 867.638 453.97C867.638 453.719 867.335 453.516 866.96 453.516C866.586 453.516 866.283 453.719 866.283 453.97C866.283 454.22 866.586 454.423 866.96 454.423Z",
    fill: "#B4B4B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M886.612 446.938C886.799 446.938 886.951 446.837 886.951 446.711C886.951 446.586 886.799 446.485 886.612 446.485C886.425 446.485 886.273 446.586 886.273 446.711C886.273 446.837 886.425 446.938 886.612 446.938ZM886.612 447.165C886.986 447.165 887.289 446.962 887.289 446.711C887.289 446.461 886.986 446.258 886.612 446.258C886.237 446.258 885.934 446.461 885.934 446.711C885.934 446.962 886.237 447.165 886.612 447.165Z",
    fill: "#B4B4B4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M847.987 446.938C848.174 446.938 848.326 446.837 848.326 446.711C848.326 446.586 848.174 446.485 847.987 446.485C847.8 446.485 847.648 446.586 847.648 446.711C847.648 446.837 847.8 446.938 847.987 446.938ZM847.987 447.165C848.361 447.165 848.665 446.962 848.665 446.711C848.665 446.461 848.361 446.258 847.987 446.258C847.613 446.258 847.31 446.461 847.31 446.711C847.31 446.962 847.613 447.165 847.987 447.165Z",
    fill: "#B4B4B4"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M866.96 440.134C867.147 440.134 867.299 440.033 867.299 439.907C867.299 439.782 867.147 439.68 866.96 439.68C866.773 439.68 866.622 439.782 866.622 439.907C866.622 440.033 866.773 440.134 866.96 440.134ZM866.96 440.361C867.335 440.361 867.638 440.158 867.638 439.907C867.638 439.657 867.335 439.454 866.96 439.454C866.586 439.454 866.283 439.657 866.283 439.907C866.283 440.158 866.586 440.361 866.96 440.361Z",
    fill: "#B4B4B4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1989_6865",
    x1: 866.96,
    y1: 440.814,
    x2: 866.96,
    y2: 457.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D3937"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1989_6865",
    x1: 866.96,
    y1: 439,
    x2: 866.96,
    y2: 455.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32302F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54504E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1989_6865",
    x1: 852.73,
    y1: 446.938,
    x2: 883.829,
    y2: 448.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98F9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7886FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1989_6865",
    x1: 867.299,
    y1: 439.361,
    x2: 867.299,
    y2: 451.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#23211F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#433F3D"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg6Speakerphone);
export default __webpack_public_path__ + "static/media/6Speakerphone.e8e5d9221b45d59330bb5e012cf5ae39.svg";
export { ForwardRef as ReactComponent };